import { createReducer, on } from '@ngrx/store';
import { DropdownItem, initialDropdownState } from '../../interfaces/dropdown.state';
import * as DropdownActions from './dropdown.actions';
import { ResetAllStores } from '../app/app.actions';

export const dropdownReducer = createReducer(
  initialDropdownState,

  on(DropdownActions.loadDropdown, (state) => ({
    ...state,
    loading: true
  })),
on(DropdownActions.loadDropdownSuccess, (state, { scope, data }) => {
  const value = data.Value ?? {};

  const commonEntries = Object.fromEntries(
    Object.entries(value)
      .filter(([key]) => !['COUNTRIES', 'STATES'].includes(key))
      .map(([k, v]) => [k, v as DropdownItem[]])
  );

  const prevScope = state.scopes[scope] ?? {
    common: {},
    countries: [],
    states: [],
    lgas: []
  };

  return {
    ...state,
    loading: false,
    scopes: {
      ...state.scopes,
      [scope]: {
        common: {
          ...prevScope.common,
          ...commonEntries
        },

         //  ONLY COMMON gets GEO
          countries:
            scope === 'COMMON'
              ? value.COUNTRIES ?? prevScope.countries
              : prevScope.countries,

          states:
            scope === 'COMMON'
              ? value.STATES ?? prevScope.states
              : prevScope.states,

          lgas:
            scope === 'COMMON'
              ? value.LGA ?? prevScope.lgas
              : prevScope.lgas,

          LGA: 
              value.LGA ? value.LGA 
              : prevScope.lgas,

        // countries: value.COUNTRIES ?? prevScope.countries,
        // states:    value.STATES    ?? prevScope.states,
        // lgas:      value.LGA       ?? prevScope.lgas
      }
    }
  };
}),

  // on(DropdownActions.loadDropdownSuccess, (state, { data }) => {
  //   const value = data.Value ?? {};

  //   // Build a properly typed record for common entries so TypeScript knows each value is DropdownItem[]
  //   const commonEntries = Object.fromEntries(
  //     Object.entries(value)
  //       .filter(([key]) => !['COUNTRIES', 'STATES', 'LGA'].includes(key))
  //       .map(([k, v]) => [k, v as DropdownItem[]])
  //   ) as { [key: string]: DropdownItem[] };

  //   return {
  //     ...state,
  //     loading: false,

  //     /** COMMON (everything except STATES, LGA, COUNTRIES) */
  //     common: {
  //       ...state.common,
  //       ...commonEntries
  //     },

  //     /** MAIN standalone dropdowns */
  //     countries: value.COUNTRIES ?? state.countries,
  //     states:    value.STATES    ?? state.states,
  //     lgas:      value.LGA       ?? state.lgas
  //   };
  // }),
  on(ResetAllStores, () => initialDropdownState),

);
